import * as React from "react";

import { IconSource } from "@livechat/design-system-react-components";

import { FilterButton } from "components/filter/FilterButton";

import { FilterLabelValueType, SelectedFilterLabel } from "./SelectedFilterLabel";

interface IProps {
  icon?: IconSource;
  title?: string;
  onRemove: () => void;
  wide?: boolean;
  label?: FilterLabelValueType;
  labelComponent?: React.ReactNode;
}

export class ReadOnlyFilterButton extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    const {
      icon,
      onRemove,
      label = "",
      title,
      wide,
      labelComponent = <SelectedFilterLabel value={label} />,
    } = this.props;

    return (
      <FilterButton
        icon={icon}
        onRemove={onRemove}
        removable
        selectedValuesLabel={labelComponent}
        shouldHideTitle
        title={title}
        wide={wide}
      />
    );
  }
}

export class ReadOnlyFilter extends React.PureComponent<IProps> {
  // FIXME: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  render() {
    return <ReadOnlyFilterButton {...this.props} />;
  }
}
